module.exports = __webpack_public_path__ + "static/media/docs-upload.f9b2a1d4.svg";